const OnShowDeleted = function(show_deleted) {
  this.collection.show_deleted = show_deleted
  this.collection.fetchData()
}
export default OnShowDeleted